import React, { useCallback, useEffect, useState } from "react";
import PublishModel from "./PublishModel";
import WarningPopup from "./warningPopup";
import { injectIntl } from "react-intl";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";

function ModelStatusChip({
  status = "Published",
  model = null,
  intl = null
}) {
  const [publishOpen, setPublishOpen] = useState(false);
  const [warninghOpen, setWarninghOpen] = useState(false);
  const chipStyle = {
    Published: {
      background: "#61B549",
      color: "#FFFFFF",
    },
    Archived: {
      background: "#E5E7ED",
      color: "#617080",
    },
    Draft: {
      background: "#none",
      border: "1px solid #617080",
      color: "#617080",
    },
    Modified: {
      background: "none",
      color: "#61B549",
      border: "1px solid #61B549",
    },
  };

  const handlePublishModel = useCallback(() => {
    // console.log("Model: ", model);
    setPublishOpen(true);
  }, [model]);

  const handlePublishModelClose = useCallback(() => {
    setPublishOpen(false);
  }, [model]);

  const handleWarningModel = useCallback(() => {
    setWarninghOpen(true);
  }, [model]);

  const handleWarningModelClose = useCallback(() => {
    setWarninghOpen(false);
  }, [model]);

  return (
    <>
      <div style={{ display: "flex", gap: "10px" }}>
        <div
          style={{
            ...{
              width: "80px",
              maxWidth: "80px",
              textAlign: "center",
              padding: "4px 18px",
              fontSize: "12px",
              fontWeight: "400",
              borderRadius: "2px",
              fontFamily: "Roboto",
            },
            ...chipStyle[status],
          }}
        >
            {injectIntlTranslation(intl, status, status || "-")}
        </div>

        {["Modified", "Draft"].includes(status) && (
          <div
            style={{
              maxWidth: "80px",
              textAlign: "center",
              padding: "4px 8px",
              fontSize: "12px",
              fontWeight: "400",
              borderRadius: "2px",
              fontFamily: "Roboto",
              background: "#1891F6",
              color: "#FFFFFF",
              cursor: "pointer",
            }}
            onClick={handlePublishModel}
          >
            {injectIntlTranslation(intl, "Publish", "Publish")}
            
          </div>
        )}

        {["Modified"].includes(status) && (
          <div
            style={{
              maxWidth: "80px",
              textAlign: "center",
              padding: "4px 8px",
              fontSize: "12px",
              fontWeight: "400",
              borderRadius: "2px",
              fontFamily: "Roboto",
              color: "#617080",
              border: "1px solid #617080",
              cursor: "pointer",
            }}
            onClick={handleWarningModel}
          >
            {injectIntlTranslation(intl, "Cancel", "Cancel")}
          </div>
        )}
      </div>

      <PublishModel
        open={publishOpen}
        onClose={handlePublishModelClose}
        model={model}
      />

      <WarningPopup
        open={warninghOpen}
        onClose={handleWarningModelClose}
        title={"Revert All Changes"}
        description={
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
        }
        saveButtonLabel={"Revert"}
        onSave={handleWarningModelClose}
      />
    </>
  );
}

export default injectIntl(ModelStatusChip);